module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.8.0.0.box.144.118.748.108.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.8.0.0.box.144.118.748.108.q.100"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.1.0.box.144.330.1264.2113.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.0.box.144.330.1264.476.q.60"
    }
  }, [_vm._v("Desserts have been popular in the South since the first settlers arrived in Virginia with visions of English puddings and double-crusted pies. By the early 1700s, the colonies were on the brink of establishing a civilized society in which the proper preparation and serving of food were important. Native fruits, nuts, dairy products, imported seasonings, and extracts were used to create desserts which were made by European rules but had a distinctly American flavor.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.1.box.145.818.1261.291.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  }), _vm._v("For many years, sugar was impractical and costly to use. It was sold in hard cones sometimes weighing ten pounds and requiring tedious chipping to produce usable crystals. It was so expensive that only the wealthy could afford it. Consequently, molasses was the usual sweetener.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.2.box.145.1121.1262.402.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  }), _vm._v("Williamsburg was the first center of festive entertaining in the South. The seat of the state's government, it was the scene of numerous balls and parties when the Assembly was in session. The hosts' English heritage was obvious at these affairs, which featured lavish assortments of creams, jellies, molds, and puddings, placed side by side on a separate table from the entrees.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.3.box.144.1547.1264.472.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.3.0"
    }
  }), _vm._v("The French influence appeared when Thomas Jefferson returned from serving as minister to France with recipes for Charlotte Russe, meringues, and other French sweets. Virginia hostesses welcomed these pretty delicacies and added them to the spectacular displays on their dessert tables. Indeed, looks were so important to colonial cooks that they often tinted desserts with spinach or beet juice, oblivious to the strange tastes that resulted.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.4.box.144.2031.1264.412.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.4.0"
    }
  }), _vm._v("Further south, Charleston soon became another important center of fine cuisine. The French Huguenot influence united with the English to popularize souffles, boiled custards, and whipped cream creations. The city's humidity prevented pie crusts from turning out well, so recipes using lady fingers came into vogue. During the slavery period and later, when servants were plentiful, it was customary in"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.9.0.0.box.221.313.1266.295.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _vm._v("\nCharleston for the lady of the house to make the dessert. This was particularly true of cake making—a time-consuming job requiring spices to be hand-ground, flour to be dried, and butter to be washed free of salt. A reputation for making good cakes was a source of pride.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.0.0.box.221.313.1275.2049.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.0.1.box.221.620.1266.400.q.70"
    }
  }, [_vm._v("Famous Charleston benne wafers owe their origins to black cooks who brought benne seeds (sesame seeds) from Africa, but the black influence is more evident in New Orleans desserts than in those of Virginia and South Carolina. Creative slaves used their talents for combining spices to flavor Creole sweets as well as other Louisiana foods.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.0.2.box.222.1045.1265.652.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.2.0"
    }
  }), _vm._v("Before the Civil War, New Orleans was a sophisticated city where luxury-loving Creoles enjoyed a fashionable social life highlighted by elaborate masked balls and stylish dinners. Planters from River Road plantations often owned town houses in the Vieux Carre, where they spent the winter attending operas and plays and revelling in the city's fast-paced social scene. Space was at a premium and houses were joined together directly on the sidewalks. Street vendors were a familiar sight on French Quarter streets, especially the pralinieres who sold Pralines and the Calas women who hawked their spicy breakfast cakes on cool mornings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.0.3.box.223.1709.1265.532.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.3.0"
    }
  }), _vm._v("The Mississippi River was the great thoroughfare of the middle South. Imported foods were shipped upstream with French furniture and Italian mantels to the mansions of the planter aristocracy along the River Road and in Natchez. Before 1830, cotton was king and Natchez boasted more millionaires than any other city in the United States except New York. Setting a fine table was a top priority with wealthy Natchezians, and elegant parties featuring sumptuous desserts took place.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.0.4.box.223.2254.1273.108.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.4.0"
    }
  }), _vm._v("In rural areas on the Mississippi, plantation life was similar to that throughout the South. A tremendous amount of"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.10.0.0.box.140.328.1269.465.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _vm._v("\ncooking was necessary to feed the owners' families and slaves plus a constant flow of visitors. Distances between towns were great and inns were scarce; travelers stopped at plantations unannounced to spend the night and often lingered for weeks. The strain on household budgets could be severe: George Washington and Thomas Jefferson suffered financial difficulties brought on by the continual influx of visitors to Mount Vernon and Monticello.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.0.0.box.140.328.1270.2055.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.0.1.box.141.817.1261.416.q.70"
    }
  }, [_vm._v("Dinner was served in mid-afternoon on most plantations, and the variety and amount of food was staggering. Diners had several choices of pies, puddings, and custards, and they consumed as many servings as they pleased. In early evening, a light meal similar to English tea was presented with cookies, cakes, and tea breads. The constant cooking kept mistress and slave in the kitchen for hours.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.0.2.box.142.1245.1261.598.q.60"
    }
  }, [_vm._v("Because plantations were self-sufficient entities, the planter's wife was usually an excellent manager, who was unlike the frivolous creature portrayed in popular novels. She found it necessary to practice strict economy and make do with food raised on the land. Her mentor was her black cook—a genius at improvisation. The women became adept at turning plantation-grown sweet potatoes, fruit, nuts, and dairy products into tasty desserts, using recipes from the few available cookbooks or creating them as they went along.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.0.3.box.141.1855.1269.408.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.3.0"
    }
  }), _vm._v("Resourcefulness was also evident in the pioneer states of Kentucky, Tennessee, and Texas. Old cookbooks reveal that pies were the most popular desserts on the frontier. They were made with whatever the hardy settlers had on hand: vinegar, jam, raisins, and fruit. Inventive cooks worked wonders with puddings, seasoning them with spices and creating sauces flavored with spirits.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.0.4.box.144.2275.1259.108.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.4.0"
    }
  }), _vm._v("The Civil War brought the South to its knees and the harsh realities of Reconstruction dismissed entertaining as a"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.11.0.0.box.229.344.1265.350.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _vm._v("\ntrivial concern. Even in such dire circumstances, Southerners found comfort in getting together with friends for simple parties where the only refreshments were inexpensive sweets. When prosperity finally returned, Southern hospitality was evident on a less elaborate scale. The glory years of the antebellum South were gone forever.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.11.0.0.box.229.344.1266.1433.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.0.1.box.230.706.1265.650.q.60"
    }
  }, [_vm._v("The dawn of the twentieth century brought enormous improvements in labor-saving tools and packaged ingredients. Mechanical eggbeaters and flour sifters were early inventions that facilitated cake making, but, today, mixers and food processors make fast work of a job that formerly took all day. Baking powder, canned coconut, and condensed milk were greeted with joy by early twentieth century cooks who would be amazed by the number of ingredients that come in cans today. Perhaps the greatest boon to dessert makers was the invention of the modern refrigerator. Now, pies and molds can finish \"cooking\" without the cook's constant attention.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.0.2.box.230.1368.1265.409.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.2.0"
    }
  }), _vm._v("The great desserts of the South will alway"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _vm._v("s be vital elements of Southern hospitality. They are the logical endings to family "), _c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _vm._v("dinners and the anticipated climax of elegant parties. They are as old-fashioned as ambrosia at Christmas and as up-to-date as"), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.1.0"
    }
  }), _vm._v(" America's current interest in back-to-basics cooking. No matter how homogeneous"), _c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v(" our society becomes, they will remain symbolic of the South.")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 12",
      "src": "data/content-0006.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0.4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96932330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0007.vue
// module id = 57
// module chunks = 0